import type { MenuItem } from '@szte-griffin/feature/app-layout/ui';
import type { AdminUserRole } from '@cappus/sdk-mecap-backend';

export const TOP_RIGHT_MENU_CONFIG: MenuItem<AdminUserRole>[] = [
  {
    name: 'my-profile',
    label: 'PROFILE_MENU.MY_PROFILE',
    routeLink: 'my-profile',
    icon: 'pct-mdi-account',
    role: ['SystemAdmin', 'Admin'],
  },
];
